import React, { FC } from 'react'
import { ModulePlaceholderVariant } from '@moonpig/web-explore-types-graphql'
import {
  CollectionTilesModule,
  CollectionTileMission,
  createTileContent,
} from '@moonpig/web-shared-components'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { ContinueCreationModuleModule } from './variant/ContinueCreationModule'
import { ShopForReminderModule } from './variant/ShopForReminder/ShopForReminderModule'
import { ModulePlaceholder } from '../../types'
import { HomepageRecentlyViewedModule } from '../HomepageRecentlyViewed'
import { ModuleSection } from '../../components/ModuleContainer'
import { ContinueJourney } from '../ContinueJourney/ContinueJourney'
import { CustomerSatisfaction } from '../../components/CustomerSatisfaction'
import { CookieListModule } from '../CookieList/CookieList'

export const PlaceholderModule: FC<ModulePlaceholder> = props => {
  const { placeholderVariant, trackingDataProps, backgroundColor } = props

  const searchCollectionsEnabled =
    useExperiment('search-use-collections-v2', {
      fallback: 'control',
    })?.toLowerCase() === 'variant'

  const renderCollectionTiles = () =>
    searchCollectionsEnabled ? (
      <ModuleSection
        backgroundColor={backgroundColor}
        padding={{ py: 8 }}
        data-testid="module-collection-tiles"
        withContainer
        fullWidthOnMobile
      >
        <CollectionTilesModule
          tiles={createTileContent(CollectionTileMission.Birthday).tiles}
          pageLocation={trackingDataProps?.pageLocation as string}
        />
      </ModuleSection>
    ) : null

  switch (placeholderVariant) {
    case ModulePlaceholderVariant.Drafts:
      return (
        <ModuleSection data-testid={`module-placeholder-${placeholderVariant}`}>
          <ContinueCreationModuleModule
            {...props}
            variant={placeholderVariant}
          />
        </ModuleSection>
      )
    case ModulePlaceholderVariant.Reminders:
      return (
        <ModuleSection data-testid={`module-placeholder-${placeholderVariant}`}>
          <ShopForReminderModule />
        </ModuleSection>
      )
    case ModulePlaceholderVariant.RecentlyViewed:
      return (
        <HomepageRecentlyViewedModule
          type="ModuleRecentlyViewed"
          trackingDataProps={{
            pageLocation: trackingDataProps?.pageLocation as string,
          }}
          backgroundColor={backgroundColor}
        />
      )
    case ModulePlaceholderVariant.ContinueJourney:
      return (
        <ModuleSection
          padding={{ py: { xs: 6, lg: 8 } }}
          data-testid={`module-placeholder-${placeholderVariant}`}
          withContainer
          fullWidthOnMobile
        >
          <ContinueJourney
            tracking={{
              pageLocation: trackingDataProps?.pageLocation as string,
              moduleProductListIndex: 1,
              moduleProductListsLength: 1,
            }}
          />
        </ModuleSection>
      )
    case ModulePlaceholderVariant.CustomerSatisfaction:
      return (
        <ModuleSection data-testid={`module-placeholder-${placeholderVariant}`}>
          <CustomerSatisfaction />
        </ModuleSection>
      )
    case ModulePlaceholderVariant.CookieList:
      return <CookieListModule />
    case ModulePlaceholderVariant.Collections:
    case ModulePlaceholderVariant.CollectionsLandingBirthday:
      return renderCollectionTiles()
    default:
      return null
  }
}
